import { useTranslation } from '@/layers/presentation/i18n/client';
import { ProgramStatusColor, UserType } from '@/types/modelEnums';
import { Program } from '@/types/models';
import { Chip } from '@nextui-org/react';
import React from 'react';
import SponsorExpandedAccessTag from './SponsorExpandedAccessTag';

interface ProgramTagsProps {
  program: Program;
  type: UserType | 'about';
  isOutOfRange?: boolean;
  isShowEaInfo?: boolean;
  isInactive?: boolean;
}

const ProgramTags: React.FC<ProgramTagsProps> = ({
  program,
  type,
  isOutOfRange,
  isShowEaInfo,
  isInactive,
}) => {
  const { t } = useTranslation();

  return (
    <span className="flex flex-row gap-2 flex-wrap">
      {isOutOfRange && (
        <Chip size="sm" color="warning" className="text-primary">
          {t('components:programCard.outOfRange')}
        </Chip>
      )}
      {program.details?.study_type === 'EXPANDED_ACCESS' && (
        <Chip size="sm" color="success">
          {t('components:programCard.expandedAccess')}
        </Chip>
      )}
      {program.details?.status === 'APPROVED_FOR_MARKETING' && (
        <Chip size="sm" color="secondary" className="bg-default-200 text-default-700">
          {t('components:programCard.approvedForMarketing')}
        </Chip>
      )}
      {type === UserType.SPONSOR && (
        <Chip
          size="sm"
          color={ProgramStatusColor[program.status as keyof typeof ProgramStatusColor]}
        >
          {program.status}
        </Chip>
      )}
      <SponsorExpandedAccessTag program={program} />
      {isInactive && (
        <Chip size="sm" color="danger">
          {t('components:programCard.inactive')}
        </Chip>
      )}
    </span>
  );
};

export default ProgramTags;
